import type {Formatter, Parser} from '../../forms/types';
import {isNull, isNullOrUndefined, isUndefined} from '../../../../utils/custom-utils';
import type { CurrencyOption } from './types';

export function modelToIdentifierFormatter(): Formatter {
    return (value: CurrencyOption) => {
        if (isNullOrUndefined(value)) {
            return null;
        }

        return value.id;
    }
}

// acceptable values can change over time (e.g. search facets update after new search)
export function identifierToModelParser(options: CurrencyOption[]): Parser {
    return (value: string) => {
        if (value === null) {
            return null;
        }
        return getOptionById(options, value);
    }
}

export function tryToFindOptionById(options: CurrencyOption[], id: string): CurrencyOption {
    if (isNull(id)) {
        return null;
    }

    return options.find((option) => option.id === id);
}

export function getOptionById(options: CurrencyOption[], id: string): CurrencyOption {
    const foundOption = tryToFindOptionById(options, id);

    if (isUndefined(foundOption)) {
        throw new Error(`Option with ID: ${id} was not found`);
    }

    return foundOption;
}